/**
 * @generated SignedSource<<f93e17b80d3ae85164056cd2cfe4ebca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NaturalLanguageToJQLWrapper$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderEmbedded">;
  readonly " $fragmentType": "NaturalLanguageToJQLWrapper";
};
export type NaturalLanguageToJQLWrapper$key = {
  readonly " $data"?: NaturalLanguageToJQLWrapper$data;
  readonly " $fragmentSpreads": FragmentRefs<"NaturalLanguageToJQLWrapper">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NaturalLanguageToJQLWrapper",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JQLBuilderEmbedded"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "119d2d3e41e27de7480aebce59802576";

export default node;
